import { LostNetwork } from "@/locales/localeid";
import { UserRole } from "@/store/app/state";
import { computed, defineComponent } from "vue";
import { fmtMsg } from "vue-glcommonui";
import { useStore } from "vuex";
import WarningMessage from "../warning-message/warning-message.vue";
import { MODULES, vuexName } from "@/store/utils";

export default defineComponent({
  components: { WarningMessage },
  setup() {
    const { getters } = useStore();
    const userRole = computed(() => getters[vuexName(MODULES.APP.GETTERS.GET_USER_ROLE, false)]);
    const isTeacher = computed(() => getters[vuexName(MODULES.AUTH.GETTERS.GET_IS_TEACHER)]);
    const isTeacherDisconnected = computed<boolean>(() => getters[vuexName(MODULES.TEACHER_ROOM.GETTERS.GET_IS_DISCONNECTED)]);
    const disconnectedMsgShown = computed(() => isTeacher.value && isTeacherDisconnected.value && userRole.value !== UserRole.UnConfirm);
    const MsgLostNetwork = computed(() => fmtMsg(LostNetwork.Message));
    return {
      MsgLostNetwork,
      disconnectedMsgShown,
    };
  },
});
